
export default function ShippingPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-gradient-to-r from-green-700 to-green-800 text-white py-16">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Shipping Information</h1>
          <p className="text-xl text-green-100">
            Fast, secure delivery of your wellness products
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-white rounded-xl shadow-lg p-6">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-truck-line text-2xl text-green-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">Free Standard Shipping</h3>
            <p className="text-gray-600">
              Enjoy free standard shipping on all orders over $75. Orders typically arrive within 5-7 business days.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-flashlight-line text-2xl text-green-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">Express Delivery</h3>
            <p className="text-gray-600">
              Need your products faster? Choose express delivery for 2-3 day shipping at checkout.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-shield-check-line text-2xl text-green-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">Secure Packaging</h3>
            <p className="text-gray-600">
              All products are carefully packaged to ensure they arrive in perfect condition, maintaining their potency.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-map-pin-line text-2xl text-green-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">Order Tracking</h3>
            <p className="text-gray-600">
              Track your order every step of the way with detailed shipping updates and delivery notifications.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Shipping Rates & Delivery Times</h2>
          
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="text-left py-4 px-4 font-semibold text-gray-800">Shipping Method</th>
                  <th className="text-left py-4 px-4 font-semibold text-gray-800">Delivery Time</th>
                  <th className="text-left py-4 px-4 font-semibold text-gray-800">Cost</th>
                  <th className="text-left py-4 px-4 font-semibold text-gray-800">Tracking</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-100">
                  <td className="py-4 px-4 text-gray-700">Standard Shipping</td>
                  <td className="py-4 px-4 text-gray-600">5-7 business days</td>
                  <td className="py-4 px-4 text-gray-600">$6.99 (Free over $75)</td>
                  <td className="py-4 px-4 text-green-600">✓ Yes</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-4 px-4 text-gray-700">Express Shipping</td>
                  <td className="py-4 px-4 text-gray-600">2-3 business days</td>
                  <td className="py-4 px-4 text-gray-600">$12.99</td>
                  <td className="py-4 px-4 text-green-600">✓ Yes</td>
                </tr>
                <tr className="border-b border-gray-100">
                  <td className="py-4 px-4 text-gray-700">Overnight Shipping</td>
                  <td className="py-4 px-4 text-gray-600">1 business day</td>
                  <td className="py-4 px-4 text-gray-600">$24.99</td>
                  <td className="py-4 px-4 text-green-600">✓ Yes</td>
                </tr>
                <tr>
                  <td className="py-4 px-4 text-gray-700">International Shipping</td>
                  <td className="py-4 px-4 text-gray-600">7-14 business days</td>
                  <td className="py-4 px-4 text-gray-600">Varies by location</td>
                  <td className="py-4 px-4 text-green-600">✓ Yes</td>
                </tr>
              </tbody>
            </table>
          </div>

          <section className="mt-8">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Shipping Zones</h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h4 className="font-semibold text-gray-700 mb-2">Domestic Shipping (US)</h4>
                <p className="text-gray-600 mb-2">We ship to all 50 states, including:</p>
                <ul className="list-disc pl-6 text-gray-600">
                  <li>Contiguous United States</li>
                  <li>Alaska & Hawaii (additional 2-3 days)</li>
                  <li>US Territories (Puerto Rico, Guam, etc.)</li>
                </ul>
              </div>
              <div>
                <h4 className="font-semibold text-gray-700 mb-2">International Shipping</h4>
                <p className="text-gray-600 mb-2">We ship worldwide to most countries:</p>
                <ul className="list-disc pl-6 text-gray-600">
                  <li>Canada & Mexico</li>
                  <li>European Union</li>
                  <li>Australia & New Zealand</li>
                  <li>Selected countries in Asia</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mt-8">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Order Processing</h3>
            <div className="bg-green-50 p-6 rounded-lg">
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 bg-green-200 rounded-full flex items-center justify-center mr-3">
                  <span className="text-green-800 font-bold text-sm">1</span>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800">Order Confirmation</h4>
                  <p className="text-gray-600 text-sm">Within 1 hour of purchase</p>
                </div>
              </div>
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 bg-green-200 rounded-full flex items-center justify-center mr-3">
                  <span className="text-green-800 font-bold text-sm">2</span>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800">Processing & Packaging</h4>
                  <p className="text-gray-600 text-sm">1-2 business days</p>
                </div>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 bg-green-200 rounded-full flex items-center justify-center mr-3">
                  <span className="text-green-800 font-bold text-sm">3</span>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800">Shipment & Tracking</h4>
                  <p className="text-gray-600 text-sm">Tracking number sent via email</p>
                </div>
              </div>
            </div>
          </section>

          <section className="mt-8">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Special Handling</h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="border border-gray-200 rounded-lg p-4">
                <h4 className="font-semibold text-gray-700 mb-2 flex items-center">
                  <i className="ri-snowflake-line mr-2 text-blue-500"></i>
                  Temperature-Sensitive Products
                </h4>
                <p className="text-gray-600 text-sm">
                  Certain products require climate-controlled shipping to maintain their efficacy. These items may have extended processing times.
                </p>
              </div>
              <div className="border border-gray-200 rounded-lg p-4">
                <h4 className="font-semibold text-gray-700 mb-2 flex items-center">
                  <i className="ri-gift-line mr-2 text-purple-500"></i>
                  Gift Orders
                </h4>
                <p className="text-gray-600 text-sm">
                  Gift orders can be shipped directly to recipients with personalized messages. Gift receipts available upon request.
                </p>
              </div>
            </div>
          </section>

          <section className="mt-8">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Shipping Restrictions</h3>
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
              <p className="text-yellow-800 mb-2"><strong>Please Note:</strong></p>
              <ul className="list-disc pl-6 text-yellow-700 text-sm">
                <li>Some products may have shipping restrictions to certain locations due to local regulations</li>
                <li>International shipments may be subject to customs duties and taxes</li>
                <li>Delivery times may be extended during peak seasons or due to weather conditions</li>
                <li>PO Box addresses may have limited shipping options</li>
              </ul>
            </div>
          </section>

          <section className="mt-8">
            <h3 className="text-xl font-bold text-gray-800 mb-4">Contact Shipping Support</h3>
            <p className="text-gray-600 mb-4">
              Have questions about your shipment? Our shipping support team is here to help.
            </p>
            <div className="grid md:grid-cols-3 gap-4">
              <div className="text-center p-4 bg-gray-50 rounded-lg">
                <i className="ri-phone-line text-2xl text-green-600 mb-2"></i>
                <p className="font-semibold text-gray-800">Call Us</p>
                <p className="text-gray-600 text-sm">+1 (555) 123-4567</p>
                <p className="text-gray-500 text-xs">Mon-Fri 9AM-6PM EST</p>
              </div>
              <div className="text-center p-4 bg-gray-50 rounded-lg">
                <i className="ri-mail-line text-2xl text-green-600 mb-2"></i>
                <p className="font-semibold text-gray-800">Email Us</p>
                <p className="text-gray-600 text-sm">shipping@ayurveda.com</p>
                <p className="text-gray-500 text-xs">Response within 24 hours</p>
              </div>
              <div className="text-center p-4 bg-gray-50 rounded-lg">
                <i className="ri-message-3-line text-2xl text-green-600 mb-2"></i>
                <p className="font-semibold text-gray-800">Live Chat</p>
                <p className="text-gray-600 text-sm">Available on our website</p>
                <p className="text-gray-500 text-xs">Mon-Fri 9AM-9PM EST</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
